import QueriesDashboard from './QueriesDashboard';

export default QueriesDashboard; 